import { useIntl } from '@capsicum/common';
import { type CodeInputError, supportSections, useSetSectionItemsLinks } from '@capsicum/socios-core';
import styled from 'styled-components';
import { match } from 'ts-pattern';

import { Link } from './CodeVerification.styled';

type CodeInputErrorMessageProps = {
	codeInputError?: CodeInputError;
};

export const CodeInputErrorMessage = ({ codeInputError }: CodeInputErrorMessageProps) => {
	const { $t } = useIntl();
	const sectionsWithLinks = useSetSectionItemsLinks(supportSections);

	return (
		codeInputError && (
			<S.Wrapper>
				{match(codeInputError)
					.with('disabled-account', () => {
						return $t<JSX.Element>('codeVerification.disabledAccount', {
							error: chunks => <S.ErrorMessage>{chunks}</S.ErrorMessage>,
							link: chunks => (
								<Link
									data-testid="codeInput-contactUs-link"
									href={
										sectionsWithLinks
											.find(x => x.title === 'profile.support')
											?.items?.find(x => x.title === 'profile.contactUsHere')?.link
									}
									target="_blank"
								>
									{chunks}
								</Link>
							)
						});
					})
					.with('disabled-region', () => (
						<S.ErrorMessage>{$t('codeVerification.disableWebAppRegion')}</S.ErrorMessage>
					))
					.otherwise(() =>
						$t<JSX.Element>('auth.welcome.codeInput.wrongCodeError', {
							error: chunks => <S.ErrorMessage>{chunks}</S.ErrorMessage>
						})
					)}
			</S.Wrapper>
		)
	);
};

namespace S {
	export const Wrapper = styled.div`
		margin-bottom: 0;
		text-align: center;
		${({ theme }) => theme.fonts.text.text4};
		margin-top: ${({ theme }) => theme.spacings.xlarge};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const ErrorMessage = styled.span`
		text-align: center;
		${({ theme }) => theme.fonts.text.text4};
		margin-top: ${({ theme }) => theme.spacings.large};
		color: ${({ theme }) => theme.colors.text.error.enabled};
	`;
}
